// 错误类型枚举
export var LoginErrorType;
(function (LoginErrorType) {
    LoginErrorType["EmptyPhoneNum"] = "emptyPhoneNum";
    LoginErrorType["InvalidPhoneNum"] = "invalidPhoneNum";
    LoginErrorType["EmptySmsNum"] = "emptySmsNum";
    LoginErrorType["InvalidSmsNum"] = "invalidSmsNum";
    LoginErrorType["ContractsUnchecked"] = "contractsUnchecked";
    LoginErrorType["LoginRequestError"] = "loginRequestError";
    LoginErrorType["SendSmsMsgRequestError"] = "sendSmsMsgRequestError";
})(LoginErrorType || (LoginErrorType = {}));
// 错误信息枚举
export var LoginErrorMessage;
(function (LoginErrorMessage) {
    LoginErrorMessage["EmptyPhoneNum"] = "\u8BF7\u586B\u5199\u624B\u673A\u53F7";
    LoginErrorMessage["InvalidPhoneNum"] = "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7";
    LoginErrorMessage["EmptySmsNum"] = "\u8BF7\u586B\u5199\u9A8C\u8BC1\u7801";
    LoginErrorMessage["InvalidSmsNum"] = "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801";
    LoginErrorMessage["ContractsUnchecked"] = "\u8BF7\u5148\u52FE\u9009\u534F\u8BAE";
})(LoginErrorMessage || (LoginErrorMessage = {}));
//# sourceMappingURL=types.js.map